const ShoppingBag = {
    title: "shoppingBag.title",
    itemsLimit: "shoppingBag.itemsLimit",
    emptyBagText: "shoppingBag.emptyBag.text",
    summaryTitle: "shoppingBag.summary.title",
    removeProduct: "shoppingBag.product.remove",
    removedFromBag: "shoppingBag.product.removedFromBag.suffix",
    button: {
        goToBackShopping: "shoppingBag.button.goToBackShopping",
        goToCheckout: "shoppingBag.button.goToCheckout",
    },
    frequentlyBoughtTogether: "shoppingBag.frequentlyBoughtTogether",
    disclaimer: "shoppingBag.disclaimer",
    expectedDelivery: "shoppingBag.expectedDelivery",
    expectedDeliveryControl: "shoppingBag.expectedDeliveryControl",
    expectedDeliveryVB: "shoppingBag.expectedDeliveryVB",
    unavailable: {
        sectionTitle: "shoppingBag.unavailable.sectionTitle",
        availableSectionTitle: "shoppingBag.unavailable.availableSectionTitle",
        stayUpdatedTitle: "shoppingBag.unavailable.stayUpdatedTitle",
        stayUpdatedText: "shoppingBag.unavailable.stayUpdatedText",
        checkoutRemovalNotice: "shoppingBag.unavailable.checkoutRemovalNotice",
        summaryLine: "shoppingBag.unavailable.summaryLine",
        subtotalAvailableSuffix: "shoppingBag.unavailable.subtotalAvailableSuffix",
    },
};

export default ShoppingBag;
